import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  loadContent () {
    const api = getApiClient(this.$store)
    const contentId = this.$route.params.id

    api.get(`contents/${contentId}`)
      .then(result => {
        this.content = result.data
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const method = this.content.id ? 'patch' : 'post'
    const options = {}
    const payload = this.content

    let endpoint = 'contents'

    if (method === 'patch') {
      options.headers = {
        'Content-Type': 'application/merge-patch+json',
      }
      endpoint = this.content['@id']
    }

    if (this.content.image && this.content.image.match(/data:image\/.*?/g)) {
      payload.image = this.content.image
    }

    api[method](endpoint, payload, options)
      .then(result => {
        this.$store.commit('app/raiseSuccess', 'Conteúdo salvo com sucesso')
        this.$router.push({
          name: 'Content',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar conteúdo')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
